import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-commontabs',
  templateUrl: './commontabs.component.html',
  styleUrls: ['./commontabs.component.css'],
})
export class CommontabsComponent implements OnInit {
  @Input() tabsArr = [];
  @Input() selectedIndex;
  @Output() tabClicked = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
  tabChange(event: MatTabChangeEvent) {
    //console.log('event', event);
    // this.tabClicked.emit(event.index);
    this.tabClicked.emit(event.tab.textLabel);
  }
}
